import { useTheme } from "@emotion/react";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  Slider,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Close } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";

const RFLTaskDialogButton = ({
  rflTask,
  updateTaskProgress,
  loading,
  errorMessage,
  ...props
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [task, setTask] = useState(rflTask);

  const [open, setOpen] = useState(false);

  return (
    <>
      <Box
        onClick={() => {
          setOpen(true);
        }}
      >
        {props.children}
      </Box>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        maxWidth="md"
        fullWidth={true}
        fullScreen={isSmallScreen}
      >
        <DialogTitle sx={{ display: "flex", flexDirection: "row" }}>
          <Box sx={{ flex: 1 }}>
            <Box>{task.name}</Box>
            <Box sx={{ fontWeight: "normal", fontSize: "16px" }}>
              {task.process}
            </Box>
          </Box>
          <Box>
            <IconButton
              onClick={() => {
                setOpen(false);
              }}
              sx={{}}
            >
              <Close />
            </IconButton>
          </Box>
          <Divider sx={{ marginY: "10px" }} />
        </DialogTitle>
        <DialogContent>
          <TextField
            type="number"
            inputProps={{
              min: 0,
              max: rflTask.goal,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={{ marginLeft: "4px" }}>
                  {rflTask.goal} {rflTask.uom} max
                </InputAdornment>
              ),
            }}
            size="small"
            fullWidth
            sx={{ marginTop: "8px" }}
            label="Progress"
            id="progress"
            name="progress"
            value={task.progress}
            onChange={(e) => {
              let val = e.target.value;
              if (Number(val ?? 0) <= task.goal) {
                setTask((prev) => ({ ...prev, progress: val }));
              }
            }}
          />

          <Box sx={{ marginTop: "8px" }}>
            <Typography sx={{ fontWeight: "bold" }}>Materials Lost</Typography>
            {task &&
              task.materials &&
              task.materials.map((material, index) => {
                return (
                  <TextField
                    type="number"
                    size="small"
                    fullWidth
                    sx={{ marginTop: "8px" }}
                    label={`${material.name}`}
                    id="material"
                    name="material"
                    value={material.quantityLost}
                    onChange={(e) => {
                      let val = e.target.value;
                      let materialsCopy = [...task.materials];
                      materialsCopy[index].quantityLost = val;
                      setTask((prev) => ({
                        ...prev,
                        materials: materialsCopy,
                      }));
                    }}
                  />
                );
              })}
          </Box>
          <Box>
            {errorMessage && (
              <Box>
                <Typography color={"red"}>{errorMessage}</Typography>
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            loading={loading}
            onClick={() => {
              updateTaskProgress(task.id, task.progress, task.materials);
            }}
          >
            Update
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RFLTaskDialogButton;
